import { render } from "./InboxView.vue?vue&type=template&id=7d35fc28"
import script from "./InboxView.vue?vue&type=script&lang=js"
export * from "./InboxView.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__